import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { ContentElement } from '../models/sections-model';

@Directive({
  selector: '[kwResolveContentElement]'
})
export class ResolveContentElementDirective implements AfterViewInit{
  @Input() contentElements:ContentElement[];
  @Input() name:string;

  @Output('selectedContentEl')  selectedContentEl = new EventEmitter<ContentElement>(); 

  constructor(private el:ElementRef, private renderer:Renderer2) { }
  
  ngAfterViewInit(): void {
    if(this.name != undefined){
      let targetEl = this.contentElements.find(contEl => contEl.name == this.name)
      if(targetEl != null && targetEl != undefined){
        //console.log(targetEl);
        this.selectedContentEl.emit(targetEl)
        //this.renderer.setAttribute(this.el.nativeElement,"id",targetEl.elId)
      }
    }
    
  }

}

// siblingChild.insertAdjacentHTML("afterend",this.htmlOpenString+this.htmlInnerString+this.htmlEndString);
